/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.16.1.0 (NJsonSchema v9.10.41.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as moment from 'moment';

export class ServiceConfig {
    public token: string;
}

export class ServiceBase {
    constructor(config: ServiceConfig) {
        if (config && config.token) {
            this._token = config.token;
        }
    }

    private _token: string;

    protected transformOptions(options: RequestInit) {
        if (this._token) {
            // @ts-expect-error temp change
            options.headers.append("Authorization", "Bearer " + this._token);
        }
        return Promise.resolve(options);
    }
}

export class AccountServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    register(input: RegisterInput): Promise<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<RegisterOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <RegisterOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterOutput>(<any>null);
    }
}

export class AttrbuteServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAttribute(input: CreateAttributeDto): Promise<EntityDto> {
        let url_ = this.baseUrl + "/api/services/app/Attrbute/CreateAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAttribute(_response);
        });
    }

    protected processCreateAttribute(response: Response): Promise<EntityDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAttributeValue(input: CreateAttributeValueDto): Promise<EntityDto> {
        let url_ = this.baseUrl + "/api/services/app/Attrbute/CreateAttributeValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAttributeValue(_response);
        });
    }

    protected processCreateAttributeValue(response: Response): Promise<EntityDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDto>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchAttributes(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Attrbute/SearchAttributes?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAttributes(_response);
        });
    }

    protected processSearchAttributes(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @attributeId (optional) 
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchAttributeValues(attributeId: number, maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Attrbute/SearchAttributeValues?";
        if (attributeId !== undefined)
            url_ += "AttributeId=" + encodeURIComponent("" + attributeId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAttributeValues(_response);
        });
    }

    protected processSearchAttributeValues(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }
}

export class CartServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getNumber(): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetNumber";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNumber(_response);
        });
    }

    protected processGetNumber(response: Response): Promise<number> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    getCart(): Promise<ShoppingCartDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetCart";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCart(_response);
        });
    }

    protected processGetCart(response: Response): Promise<ShoppingCartDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ShoppingCartDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartDto>(<any>null);
    }

    /**
     * @dto (optional) 
     * @return Success
     */
    saveCart(dto: ShoppingCartDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Cart/SaveCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCart(_response);
        });
    }

    protected processSaveCart(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCart(): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Cart/ClearCart";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClearCart(_response);
        });
    }

    protected processClearCart(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}



export class CatalogServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCatalog(input: CreateCatalogDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/CreateCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCatalog(_response);
        });
    }

    protected processCreateCatalog(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addProductsToCategory(input: AddOrRemoveProductsInput): Promise<AddProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/AddProductsToCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddProductsToCategory(_response);
        });
    }

    protected processAddProductsToCategory(response: Response): Promise<AddProductsOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <AddProductsOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddProductsOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCatalogForEdit(id: number): Promise<EditCatalogDto> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetCatalogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForEdit(_response);
        });
    }

    protected processGetCatalogForEdit(response: Response): Promise<EditCatalogDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditCatalogDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCatalogDto>(<any>null);
    }

    /**
     * @productId (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getCatalogsByProductId(productId: number, maxResultCount: number, skipCount: number, filter: string, sorting: string): Promise<PagedResultDtoOfClientCatalogDto> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetCatalogsByProductId?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogsByProductId(_response);
        });
    }

    protected processGetCatalogsByProductId(response: Response): Promise<PagedResultDtoOfClientCatalogDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfClientCatalogDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfClientCatalogDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCatalog(input: UpdateCatalogDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/UpdateCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCatalog(_response);
        });
    }

    protected processUpdateCatalog(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteCatalog(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/DeleteCatalog?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCatalog(_response);
        });
    }

    protected processDeleteCatalog(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @catalogId (optional) 
     * @return Success
     */
    removeProductsFromCategory(categoryId: number, catalogId: number, productIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/RemoveProductsFromCategory?";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (productIds === undefined || productIds === null)
            throw new Error("The parameter 'productIds' must be defined and cannot be null.");
        else
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveProductsFromCategory(_response);
        });
    }

    protected processRemoveProductsFromCategory(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class CategoryServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCategoryForClientCatalog(input: CreateClientCategoryDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Category/CreateCategoryForClientCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCategoryForClientCatalog(_response);
        });
    }

    protected processCreateCategoryForClientCatalog(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCategoryForMasterCatalog(input: CreateCategoryDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Category/CreateCategoryForMasterCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCategoryForMasterCatalog(_response);
        });
    }

    protected processCreateCategoryForMasterCatalog(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @return Success
     */
    getCategoriesForClientCatalog(catalogId: number): Promise<ListResultDtoOfGetСategoriesDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetCategoriesForClientCatalog?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoriesForClientCatalog(_response);
        });
    }

    protected processGetCategoriesForClientCatalog(response: Response): Promise<ListResultDtoOfGetСategoriesDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfGetСategoriesDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfGetСategoriesDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCategoriesForMasterCatalog(): Promise<ListResultDtoOfGetСategoriesDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetCategoriesForMasterCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoriesForMasterCatalog(_response);
        });
    }

    protected processGetCategoriesForMasterCatalog(response: Response): Promise<ListResultDtoOfGetСategoriesDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfGetСategoriesDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfGetСategoriesDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCategoryForClientCatalog(input: UpdateCategoryDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Category/UpdateCategoryForClientCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCategoryForClientCatalog(_response);
        });
    }

    protected processUpdateCategoryForClientCatalog(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @id (optional) 
     * @return Success
     */
    deleteCategoryFromClientCatalog(catalogId: number, id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/DeleteCategoryFromClientCatalog?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCategoryFromClientCatalog(_response);
        });
    }

    protected processDeleteCategoryFromClientCatalog(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteCategoryFromMasterCatalog(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/DeleteCategoryFromMasterCatalog?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCategoryFromMasterCatalog(_response);
        });
    }

    protected processDeleteCategoryFromMasterCatalog(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ClientServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createClient(input: CreateClientDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Client/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getClients(maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfClientListDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClients?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: Response): Promise<PagedResultDtoOfClientListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfClientListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfClientListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getClientForEdit(id: number): Promise<EditClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientForEdit(_response);
        });
    }

    protected processGetClientForEdit(response: Response): Promise<EditClientDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditClientDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditClientDto>(<any>null);
    }

    /**
     * @return Success
     */
    getClientsTree(): Promise<ListResultDtoOfClientUnitShortDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientsTree";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientsTree(_response);
        });
    }

    protected processGetClientsTree(response: Response): Promise<ListResultDtoOfClientUnitShortDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfClientUnitShortDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfClientUnitShortDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    searchClientById(id: number): Promise<SearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/SearchClientById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchClientById(_response);
        });
    }

    protected processSearchClientById(response: Response): Promise<SearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <SearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchOutputDto>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchClients(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/SearchClients?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchClients(_response);
        });
    }

    protected processSearchClients(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateClient(input: UpdateClientDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteClient(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/DeleteClient?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DivisionServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDivision(input: CreateDivisionDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Division/CreateDivision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDivision(_response);
        });
    }

    protected processCreateDivision(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @clientId (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getDivisionsByClientId(clientId: number, maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfDivisionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Division/GetDivisionsByClientId?";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDivisionsByClientId(_response);
        });
    }

    protected processGetDivisionsByClientId(response: Response): Promise<PagedResultDtoOfDivisionListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfDivisionListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfDivisionListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getDivisionForEdit(id: number): Promise<EditDivisionDto> {
        let url_ = this.baseUrl + "/api/services/app/Division/GetDivisionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDivisionForEdit(_response);
        });
    }

    protected processGetDivisionForEdit(response: Response): Promise<EditDivisionDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditDivisionDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditDivisionDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    searchDivisionById(id: number): Promise<SearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Division/SearchDivisionById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchDivisionById(_response);
        });
    }

    protected processSearchDivisionById(response: Response): Promise<SearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <SearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchOutputDto>(<any>null);
    }

    /**
     * @clientId (optional) 
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchDivisionsByClientId(clientId: number, maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Division/SearchDivisionsByClientId?";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchDivisionsByClientId(_response);
        });
    }

    protected processSearchDivisionsByClientId(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDivision(input: UpdateDivisionDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Division/UpdateDivision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDivision(_response);
        });
    }

    protected processUpdateDivision(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteDivision(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Division/DeleteDivision?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDivision(_response);
        });
    }

    protected processDeleteDivision(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExcelExportServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportClientInvoice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ExcelExport/ExportClientInvoice?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportClientInvoice(_response);
        });
    }

    protected processExportClientInvoice(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportInvoice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ExcelExport/ExportInvoice?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportInvoice(_response);
        });
    }

    protected processExportInvoice(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ApiServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    files(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFiles(_response);
        });
    }

    protected processFiles(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class InvoiceServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @clientUnitId (optional) 
     * @filter (optional) 
     * @startDate (optional) 
     * @dueDate (optional) 
     * @showArchived (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getClientInvoices(clientUnitId: number, filter: string, startDate: moment.Moment, dueDate: moment.Moment, showArchived: boolean, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfClientInvoiceListDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetClientInvoices?";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (showArchived !== undefined)
            url_ += "ShowArchived=" + encodeURIComponent("" + showArchived) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientInvoices(_response);
        });
    }

    protected processGetClientInvoices(response: Response): Promise<PagedResultDtoOfClientInvoiceListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfClientInvoiceListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfClientInvoiceListDto>(<any>null);
    }

    /**
     * @clientUnitId (optional) 
     * @filter (optional) 
     * @startDate (optional) 
     * @dueDate (optional) 
     * @showArchived (optional)  
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getInvoices(clientUnitId: number, filter: string, startDate: moment.Moment, dueDate: moment.Moment, showArchived: boolean, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfInvoceListDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoices?";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (showArchived !== undefined)
            url_ += "ShowArchived=" + encodeURIComponent("" + showArchived) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: Response): Promise<PagedResultDtoOfInvoceListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfInvoceListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfInvoceListDto>(<any>null);
    }

    /**
 * @invoiceId (optional) 
 * @archive (optional) 
 * @return Success
 */
    setInvoiceArchive(invoiceId: number, archive: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SetInvoiceArchive?";
        if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (archive !== undefined)
            url_ += "archive=" + encodeURIComponent("" + archive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetInvoiceArchive(_response);
        });
    }

    protected processSetInvoiceArchive(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**

    /**
     * @id (optional) 
     * @return Success
     */
    getClientInvoiceForEdit(id: number): Promise<EditClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetClientInvoiceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientInvoiceForEdit(_response);
        });
    }

    protected processGetClientInvoiceForEdit(response: Response): Promise<EditClientInvoiceDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditClientInvoiceDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditClientInvoiceDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInvoiceDetails(id: number): Promise<InvoiceDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceDetails?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInvoiceDetails(_response);
        });
    }

    protected processGetInvoiceDetails(response: Response): Promise<InvoiceDetailsDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <InvoiceDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDetailsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateClientInvoice(input: UpdateClientInvoiceDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/UpdateClientInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClientInvoice(_response);
        });
    }

    protected processUpdateClientInvoice(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInvoicePaidStatus(input: UpdateInvoicePaidStatusDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/UpdateInvoicePaidStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInvoicePaidStatus(_response);
        });
    }

    protected processUpdateInvoicePaidStatus(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendClientInvoice(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SendClientInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendClientInvoice(_response);
        });
    }

    protected processSendClientInvoice(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendClientInvoices(input: SendClientInvoiceDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SendClientInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendClientInvoices(_response);
        });
    }

    protected processSendClientInvoices(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class LocationServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createLocation(input: CreateLocationDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Location/CreateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAddressOverride(input: CreateAddressOverrideDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Location/CreateAddressOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAddressOverride(_response);
        });
    }

    protected processCreateAddressOverride(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @divisionId (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getLocationsByDivisionId(divisionId: number, maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfLocationListDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLocationsByDivisionId?";
        if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationsByDivisionId(_response);
        });
    }

    protected processGetLocationsByDivisionId(response: Response): Promise<PagedResultDtoOfLocationListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfLocationListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfLocationListDto>(<any>null);
    }

    /**
     * @productId (optional) 
     * @divisionId (optional) 
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchLocationsByDivisionId(productId: number, divisionId: number, maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/SearchLocationsByDivisionId?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchLocationsByDivisionId(_response);
        });
    }

    protected processSearchLocationsByDivisionId(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLocationForEdit(id: number): Promise<EditLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLocationForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationForEdit(_response);
        });
    }

    protected processGetLocationForEdit(response: Response): Promise<EditLocationDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditLocationDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditLocationDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAddressOverrideForEdit(id: number): Promise<EditAddressOverrideDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAddressOverrideForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAddressOverrideForEdit(_response);
        });
    }

    protected processGetAddressOverrideForEdit(response: Response): Promise<EditAddressOverrideDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditAddressOverrideDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAddressOverrideDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLocation(input: UpdateLocationDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Location/UpdateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAddressOverride(input: UpdateAddressOverrideDto): Promise<UpdateAddressOverrideDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/UpdateAddressOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAddressOverride(_response);
        });
    }

    protected processUpdateAddressOverride(response: Response): Promise<UpdateAddressOverrideDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <UpdateAddressOverrideDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAddressOverrideDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteLocation(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Location/DeleteLocation?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteAddressOverride(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Location/DeleteAddressOverride?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAddressOverride(_response);
        });
    }

    protected processDeleteAddressOverride(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MedicalSpecialityServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchMedicalSpecialities(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpeciality/SearchMedicalSpecialities?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchMedicalSpecialities(_response);
        });
    }

    protected processSearchMedicalSpecialities(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }
}

export class NotesServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchNotes(maxResultCount: number, filter: string): Promise<ListResultDtoOfNoteSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Notes/SearchNotes?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchNotes(_response);
        });
    }

    protected processSearchNotes(response: Response): Promise<ListResultDtoOfNoteSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfNoteSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfNoteSearchOutputDto>(<any>null);
    }
}

export class OrderServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveOrder(input: SaveOrderDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Order/SaveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveOrder(_response);
        });
    }

    protected processSaveOrder(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    submitOrder(input: SubmitOrderInputDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Order/SubmitOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitOrder(_response);
        });
    }

    protected processSubmitOrder(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @clientUnitd (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getMyOrders(clientUnitd: number, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfMyOrdersListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetMyOrders?";
        if (clientUnitd !== undefined)
            url_ += "ClientUnitd=" + encodeURIComponent("" + clientUnitd) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyOrders(_response);
        });
    }

    protected processGetMyOrders(response: Response): Promise<PagedResultDtoOfMyOrdersListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfMyOrdersListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfMyOrdersListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMyOrderForEdit(id: number): Promise<EditMyOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetMyOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyOrderForEdit(_response);
        });
    }

    protected processGetMyOrderForEdit(response: Response): Promise<EditMyOrderDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditMyOrderDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMyOrderDto>(<any>null);
    }

    getAllOrdersForSCMDashboard(clientUnitd: number, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfSCMDashboardOrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllOrdersForSCMDashboard?";
        if (clientUnitd !== undefined)
            url_ += "ClientUnitd=" + encodeURIComponent("" + clientUnitd) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllOrdersForSCMDashboard(_response);
        });
    }

    protected processGetAllOrdersForSCMDashboard(response: Response): Promise<PagedResultDtoOfSCMDashboardOrderListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfSCMDashboardOrderListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfSCMDashboardOrderListDto>(<any>null);
    }

    /**
     * @clientUnitd (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getAllOrders(clientUnitd: number, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfBuyerOrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllOrders?";
        if (clientUnitd !== undefined)
            url_ += "ClientUnitd=" + encodeURIComponent("" + clientUnitd) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllOrders(_response);
        });
    }

    protected processGetAllOrders(response: Response): Promise<PagedResultDtoOfBuyerOrderListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfBuyerOrderListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfBuyerOrderListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAllOrderForEdit(id: number): Promise<EditAllOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllOrderForEdit(_response);
        });
    }

    protected processGetAllOrderForEdit(response: Response): Promise<EditAllOrderDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditAllOrderDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAllOrderDto>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @dueDate (optional) 
     * @locationId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getBuyerOrders(startDate: moment.Moment, dueDate: moment.Moment, locationId: number, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfBuyerOrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetBuyerOrders?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerOrders(_response);
        });
    }

    protected processGetBuyerOrders(response: Response): Promise<PagedResultDtoOfBuyerOrderListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfBuyerOrderListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfBuyerOrderListDto>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @dueDate (optional) 
     * @clientUnitType (optional) 
     * @clientUnitId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getUncomparedOrders(startDate: moment.Moment, dueDate: moment.Moment, clientUnitType: ClientUnitType, clientUnitId: number, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfUncomparedOrdersListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetUncomparedOrders?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (clientUnitType !== undefined)
            url_ += "ClientUnitType=" + encodeURIComponent("" + clientUnitType) + "&";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUncomparedOrders(_response);
        });
    }

    protected processGetUncomparedOrders(response: Response): Promise<PagedResultDtoOfUncomparedOrdersListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfUncomparedOrdersListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfUncomparedOrdersListDto>(<any>null);
    }

    /**
     * @clientUnitId (optional) 
     * @startDate (optional) 
     * @dueDate (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getCompanyPackingSlips(clientUnitId: number, startDate: moment.Moment, dueDate: moment.Moment, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfPackingSlipOrdersListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCompanyPackingSlips?";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyPackingSlips(_response);
        });
    }

    protected processGetCompanyPackingSlips(response: Response): Promise<PagedResultDtoOfPackingSlipOrdersListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfPackingSlipOrdersListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfPackingSlipOrdersListDto>(<any>null);
    }

    /**
     * @clientUnitId (optional) 
     * @startDate (optional) 
     * @dueDate (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getPackingSlips(clientUnitId: number, startDate: moment.Moment, dueDate: moment.Moment, filter: string, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfPackingSlipOrdersListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackingSlips?";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPackingSlips(_response);
        });
    }

    protected processGetPackingSlips(response: Response): Promise<PagedResultDtoOfPackingSlipOrdersListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfPackingSlipOrdersListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfPackingSlipOrdersListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPackingSlipDetails(id: number): Promise<PackingSlipDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackingSlipDetails?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPackingSlipDetails(_response);
        });
    }

    protected processGetPackingSlipDetails(response: Response): Promise<PackingSlipDetailsDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PackingSlipDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PackingSlipDetailsDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getBuyerOrderForEdit(id: number): Promise<EditBuyerOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetBuyerOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerOrderForEdit(_response);
        });
    }

    protected processGetBuyerOrderForEdit(response: Response): Promise<EditBuyerOrderDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditBuyerOrderDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditBuyerOrderDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUncomparedOrderForEdit(id: number): Promise<EditUncomparedOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetUncomparedOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUncomparedOrderForEdit(_response);
        });
    }

    protected processGetUncomparedOrderForEdit(response: Response): Promise<EditUncomparedOrderDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditUncomparedOrderDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUncomparedOrderDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPackingSlipOrderForEdit(id: number): Promise<EditPackingSlipOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackingSlipOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPackingSlipOrderForEdit(_response);
        });
    }

    protected processGetPackingSlipOrderForEdit(response: Response): Promise<EditPackingSlipOrderDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditPackingSlipOrderDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditPackingSlipOrderDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelAllOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CancelAllOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelAllOrder(_response);
        });
    }

    protected processCancelAllOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approveAllOrder(input: EntityDtoOfInt64): Promise<ErrorsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/ApproveAllOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveAllOrder(_response);
        });
    }

    protected processApproveAllOrder(response: Response): Promise<ErrorsOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ErrorsOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorsOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    submitAllOrder(input: EntityDtoOfInt64): Promise<ErrorsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/SubmitAllOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitAllOrder(_response);
        });
    }

    protected processSubmitAllOrder(response: Response): Promise<ErrorsOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ErrorsOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorsOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllOrder(input: UpdateOrderDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateAllOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAllOrder(_response);
        });
    }

    protected processUpdateAllOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approveBuyerOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ApproveBuyerOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveBuyerOrder(_response);
        });
    }

    protected processApproveBuyerOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    submitBuyerOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/SubmitBuyerOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitBuyerOrder(_response);
        });
    }

    protected processSubmitBuyerOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBuyerOrder(input: UpdateOrderDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateBuyerOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBuyerOrder(_response);
        });
    }

    protected processUpdateBuyerOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUncomparedOrder(input: UpdateUncomparedOrderDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateUncomparedOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUncomparedOrder(_response);
        });
    }

    protected processUpdateUncomparedOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelBuyerOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CancelBuyerOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBuyerOrder(_response);
        });
    }

    protected processCancelBuyerOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approveUncomparedOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ApproveUncomparedOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveUncomparedOrder(_response);
        });
    }

    protected processApproveUncomparedOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePackingSlipOrder(input: UpdatePackingSlipOrderDto): Promise<UpdatePackingSlipOutput> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdatePackingSlipOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePackingSlipOrder(_response);
        });
    }

    protected processUpdatePackingSlipOrder(response: Response): Promise<UpdatePackingSlipOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <UpdatePackingSlipOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePackingSlipOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reconcilePackingSlipOrder(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ReconcilePackingSlipOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReconcilePackingSlipOrder(_response);
        });
    }

    protected processReconcilePackingSlipOrder(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PermissionServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Promise<ListResultDtoOfPermissionNodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: Response): Promise<ListResultDtoOfPermissionNodeDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfPermissionNodeDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfPermissionNodeDto>(<any>null);
    }

    /**
     * @roles (optional) 
     * @return Success
     */
    getRolesPermissions(roles: string[]): Promise<ListResultDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetRolesPermissions?";
        if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRolesPermissions(_response);
        });
    }

    protected processGetRolesPermissions(response: Response): Promise<ListResultDtoOfString> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfString>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfString>(<any>null);
    }
}

export class PricingDetailServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPricesForProduct(id: number): Promise<ListResultDtoOfPricingDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/PricingDetail/GetPricesForProduct?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPricesForProduct(_response);
        });
    }

    protected processGetPricesForProduct(response: Response): Promise<ListResultDtoOfPricingDetailDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfPricingDetailDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfPricingDetailDto>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @productPrices (optional) 
     * @return Success
     */
    comparePrices(catalogId: number, productPrices: any[]): Promise<ListResultDtoOfProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/PricingDetail/ComparePrices?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (productPrices !== undefined)
            productPrices && productPrices.forEach((item, index) => {
                for (const attr in item)
                    url_ += "ProductPrices[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComparePrices(_response);
        });
    }

    protected processComparePrices(response: Response): Promise<ListResultDtoOfProductPriceDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfProductPriceDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfProductPriceDto>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @productId (optional) 
     * @return Success
     */
    getPriceForProduct(catalogId: number, productId: number): Promise<ProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/PricingDetail/GetPriceForProduct?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriceForProduct(_response);
        });
    }

    protected processGetPriceForProduct(response: Response): Promise<ProductPriceDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ProductPriceDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductPriceDto>(<any>null);
    }

    /**
     * @locationId (optional) 
     * @productIds (optional) 
     * @return Success
     */
    getPricesForLocation(locationId: number, productIds: number[]): Promise<ListResultDtoOfProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/PricingDetail/GetPricesForLocation?";
        if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPricesForLocation(_response);
        });
    }

    protected processGetPricesForLocation(response: Response): Promise<ListResultDtoOfProductPriceDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfProductPriceDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfProductPriceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setPricesForCatalogs(input: SetPricesForCatalogsInput): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PricingDetail/SetPricesForCatalogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPricesForCatalogs(_response);
        });
    }

    protected processSetPricesForCatalogs(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createProduct(input: CreateProductDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @isArchived (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getProductsForMasterCatalog(categoryId: number, isArchived: boolean, maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductsForMasterCatalog?";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductsForMasterCatalog(_response);
        });
    }

    protected processGetProductsForMasterCatalog(response: Response): Promise<PagedResultDtoOfProductListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfProductListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfProductListDto>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @catalogId (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getProductsForClientCatalog(categoryId: number, catalogId: number, maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductsForClientCatalog?";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductsForClientCatalog(_response);
        });
    }

    protected processGetProductsForClientCatalog(response: Response): Promise<PagedResultDtoOfProductListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfProductListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfProductListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSimilarProducts(id: number): Promise<ListResultDtoOfSimilarProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetSimilarProducts?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimilarProducts(_response);
        });
    }

    protected processGetSimilarProducts(response: Response): Promise<ListResultDtoOfSimilarProductDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSimilarProductDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSimilarProductDto>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @id (optional) 
     * @return Success
     */
    getSimilarProductsForClientCatalog(catalogId: number, id: number): Promise<ListResultDtoOfClientSimilarProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetSimilarProductsForClientCatalog?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimilarProductsForClientCatalog(_response);
        });
    }

    protected processGetSimilarProductsForClientCatalog(response: Response): Promise<ListResultDtoOfClientSimilarProductDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfClientSimilarProductDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfClientSimilarProductDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductDetails(id: number): Promise<ProductDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductDetails?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductDetails(_response);
        });
    }

    protected processGetProductDetails(response: Response): Promise<ProductDetailsDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ProductDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDetailsDto>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @id (optional) 
     * @return Success
     */
    getClientProductDetails(catalogId: number, id: number): Promise<ClientProductDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetClientProductDetails?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientProductDetails(_response);
        });
    }

    protected processGetClientProductDetails(response: Response): Promise<ClientProductDetailsDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ClientProductDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientProductDetailsDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductAttributes(id: number): Promise<ListResultDtoOfSearchProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductAttributes?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductAttributes(_response);
        });
    }

    protected processGetProductAttributes(response: Response): Promise<ListResultDtoOfSearchProductAttributeDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchProductAttributeDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchProductAttributeDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductForEdit(id: number): Promise<EditProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductForEdit(_response);
        });
    }

    protected processGetProductForEdit(response: Response): Promise<EditProductDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditProductDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditProductDto>(<any>null);
    }

    /**
     * @productId (optional) 
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchSimilarProducts(productId: number, maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchSimilarProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/SearchSimilarProducts?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSimilarProducts(_response);
        });
    }

    protected processSearchSimilarProducts(response: Response): Promise<ListResultDtoOfSearchSimilarProductDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchSimilarProductDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchSimilarProductDto>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @return Success
     */
    getCategoryProducts(categoryId: number): Promise<ListResultDtoOfCategoryProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetCategoryProducts?";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoryProducts(_response);
        });
    }

    protected processGetCategoryProducts(response: Response): Promise<ListResultDtoOfCategoryProductDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfCategoryProductDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfCategoryProductDto>(<any>null);
    }

    /**
     * @isArchived (optional) 
     * @filter (optional) 
     * @return Success
     */
    getCountForMasterCatalog(isArchived: boolean, filter: string): Promise<ListResultDtoOfCountDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetCountForMasterCatalog?";
        if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountForMasterCatalog(_response);
        });
    }

    protected processGetCountForMasterCatalog(response: Response): Promise<ListResultDtoOfCountDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfCountDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfCountDtoOfInt64>(<any>null);
    }

    /**
     * @catalogId (optional) 
     * @filter (optional) 
     * @return Success
     */
    getCountForClientCatalog(catalogId: number, filter: string): Promise<ListResultDtoOfCountDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetCountForClientCatalog?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountForClientCatalog(_response);
        });
    }

    protected processGetCountForClientCatalog(response: Response): Promise<ListResultDtoOfCountDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfCountDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfCountDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProduct(input: UpdateProductDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unArchiveProduct(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/UnArchiveProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnArchiveProduct(_response);
        });
    }

    protected processUnArchiveProduct(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    archiveProduct(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/ArchiveProduct?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveProduct(_response);
        });
    }

    protected processArchiveProduct(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductSectionServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProducSections(): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductSection/GetProducSections";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProducSections(_response);
        });
    }

    protected processGetProducSections(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }
}

export class PurchaseHistoryServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @catalogId (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    getPurchasedProducts(catalogId: number, maxResultCount: number, skipCount: number, filter: string): Promise<PagedResultDtoOfPurchasedProductsListOutput> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseHistory/GetPurchasedProducts?";
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchasedProducts(_response);
        });
    }

    protected processGetPurchasedProducts(response: Response): Promise<PagedResultDtoOfPurchasedProductsListOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfPurchasedProductsListOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfPurchasedProductsListOutput>(<any>null);
    }
}

export class RoleServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createRole(input: CreateRoleDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRole(id: number): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: Response): Promise<RoleDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <RoleDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getRoles(maxResultCount: number, skipCount: number, filter: string, sorting: string): Promise<PagedResultDtoOfListRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<PagedResultDtoOfListRoleDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfListRoleDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfListRoleDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateRole(input: UpdateRoleDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Role/UpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteRole(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SessionServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: Response): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <GetCurrentLoginInformationsOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

export class SkuSegmentServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSkuPrefix(input: CreateSkuDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/SkuSegment/CreateSkuPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSkuPrefix(_response);
        });
    }

    protected processCreateSkuPrefix(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchSkuPrefixes(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/SkuSegment/SearchSkuPrefixes?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSkuPrefixes(_response);
        });
    }

    protected processSearchSkuPrefixes(response: Response): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDtoOfInt64>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchSkuSuffixes(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/SkuSegment/SearchSkuSuffixes?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSkuSuffixes(_response);
        });
    }

    protected processSearchSkuSuffixes(response: Response): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDtoOfInt64>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSkuPrefix(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SkuSegment/DeleteSkuPrefix?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSkuPrefix(_response);
        });
    }

    protected processDeleteSkuPrefix(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SpendingTermServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSpendingTerms(): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SpendingTerm/GetAllSpendingTerms";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSpendingTerms(_response);
        });
    }

    protected processGetAllSpendingTerms(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultSpendingTerm(): Promise<SearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SpendingTerm/GetDefaultSpendingTerm";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultSpendingTerm(_response);
        });
    }

    protected processGetDefaultSpendingTerm(response: Response): Promise<SearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <SearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchOutputDto>(<any>null);
    }
}

export class StateServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchStates(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/State/SearchStates?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchStates(_response);
        });
    }

    protected processSearchStates(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }
}

export class SupervisorServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserSupervisors(id: number): Promise<ListResultDtoOfUserSupervisorDto> {
        let url_ = this.baseUrl + "/api/services/app/Supervisor/GetUserSupervisors?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSupervisors(_response);
        });
    }

    protected processGetUserSupervisors(response: Response): Promise<ListResultDtoOfUserSupervisorDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfUserSupervisorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfUserSupervisorDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserSupervisors(input: UpdateUserSupervisorsInput): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Supervisor/UpdateUserSupervisors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSupervisors(_response);
        });
    }

    protected processUpdateUserSupervisors(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TokenAuthServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthenticateResultModel> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <AuthenticateResultModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Promise<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalAuthenticationProviders(_response);
        });
    }

    protected processGetExternalAuthenticationProviders(response: Response): Promise<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExternalLoginProviderInfoModel[]>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel): Promise<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExternalAuthenticate(_response);
        });
    }

    protected processExternalAuthenticate(response: Response): Promise<ExternalAuthenticateResultModel> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExternalAuthenticateResultModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalAuthenticateResultModel>(<any>null);
    }
}

export class UnitOfMeasureServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPackageType(input: CreateUnitOfMeasureInput): Promise<EntityDtoOfInt32> {
        let url_ = this.baseUrl + "/api/services/app/UnitOfMeasure/CreatePackageType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePackageType(_response);
        });
    }

    protected processCreatePackageType(response: Response): Promise<EntityDtoOfInt32> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt32>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt32>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchDimensions(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/UnitOfMeasure/SearchDimensions?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchDimensions(_response);
        });
    }

    protected processSearchDimensions(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchPackageTypes(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/UnitOfMeasure/SearchPackageTypes?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPackageTypes(_response);
        });
    }

    protected processSearchPackageTypes(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePackageType(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UnitOfMeasure/DeletePackageType?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePackageType(_response);
        });
    }

    protected processDeletePackageType(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PasswordServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input
     * @return Success
     */
    resetPassword(input: ResetPasswordDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Password/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <void>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    //sendEmail

        /**
     * @input
     * @return Success
     */
    sendEmail(input: ResetPasswordEmailDto): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Password/SendResetPasswordEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <void>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UserServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUser(input: CreateUserDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @clientUnitId (optional) 
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchUsers(clientUnitId: number, maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/SearchUsers?";
        if (clientUnitId !== undefined)
            url_ += "ClientUnitId=" + encodeURIComponent("" + clientUnitId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @filter (optional) 
     * @return Success
     */
    searchSupplyChainManagers(maxResultCount: number, filter: string): Promise<ListResultDtoOfSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/SearchSupplyChainManagers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSupplyChainManagers(_response);
        });
    }

    protected processSearchSupplyChainManagers(response: Response): Promise<ListResultDtoOfSearchOutputDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDto>(<any>null);
    }

    /**
     * @totalAmount (optional) 
     * @locationId (optional) 
     * @return Success
     */
    checkSpendLimit(totalAmount: number, locationId: number): Promise<CheckSpendLimitOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/CheckSpendLimit?";
        if (totalAmount !== undefined)
            url_ += "TotalAmount=" + encodeURIComponent("" + totalAmount) + "&";
        if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckSpendLimit(_response);
        });
    }

    protected processCheckSpendLimit(response: Response): Promise<CheckSpendLimitOutput> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <CheckSpendLimitOutput>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckSpendLimitOutput>(<any>null);
    }

    /**
     * @clientId (optional) 
     * @filter (optional) 
     * @inactive (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getUsers(clientId: number, filter: string, inactive: boolean, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfListUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (inactive !== undefined)
            url_ += "Inactive=" + encodeURIComponent("" + inactive) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<PagedResultDtoOfListUserDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfListUserDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfListUserDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForEdit(id: number): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserForEdit(_response);
        });
    }

    protected processGetUserForEdit(response: Response): Promise<EditUserDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditUserDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserOverridedLocations(id: number): Promise<ListResultDtoOfAddressOverrideListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserOverridedLocations?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserOverridedLocations(_response);
        });
    }

    protected processGetUserOverridedLocations(response: Response): Promise<ListResultDtoOfAddressOverrideListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfAddressOverrideListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfAddressOverrideListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserPermissions(id: number): Promise<ListResultDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissions?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: Response): Promise<ListResultDtoOfString> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfString>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfString>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUser(input: UpdateUserDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserPermissions(_response);
        });
    }

    protected processUpdateUserPermissions(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deactivateUser(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeactivateUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reactivateUser(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ReactivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivateUser(_response);
        });
    }

    protected processReactivateUser(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VendorServiceProxy extends ServiceBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configuration: ServiceConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVendor(input: CreateVendorDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVendor(_response);
        });
    }

    protected processCreateVendor(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @filter (optional) 
     * @isArchived (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getVendors(filter: string, isArchived: boolean, sorting: string, skipCount: number, maxResultCount: number): Promise<PagedResultDtoOfVendorListDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetVendors?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendors(_response);
        });
    }

    protected processGetVendors(response: Response): Promise<PagedResultDtoOfVendorListDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <PagedResultDtoOfVendorListDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDtoOfVendorListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getVendorForEdit(id: number): Promise<EditVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetVendorForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const options_ = <RequestInit>{
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorForEdit(_response);
        });
    }

    protected processGetVendorForEdit(response: Response): Promise<EditVendorDto> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EditVendorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditVendorDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    searchVendors(input: SearchInputDto): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/SearchVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchVendors(_response);
        });
    }

    protected processSearchVendors(response: Response): Promise<ListResultDtoOfSearchOutputDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ListResultDtoOfSearchOutputDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultDtoOfSearchOutputDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateVendor(input: UpdateVendorDto): Promise<EntityDtoOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/UpdateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVendor(_response);
        });
    }

    protected processUpdateVendor(response: Response): Promise<EntityDtoOfInt64> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <EntityDtoOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDtoOfInt64>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unarchiveVendor(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/UnarchiveVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnarchiveVendor(_response);
        });
    }

    protected processUnarchiveVendor(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    archiveVendor(input: EntityDtoOfInt64): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/ArchiveVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        const options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveVendor(_response);
        });
    }

    protected processArchiveVendor(response: Response): Promise<void> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v, k) => _headers[k] = v); }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface RegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;
}

export interface RegisterOutput {
    canLogin: boolean;
}

export interface CreateAttributeDto {
    name: string;
}

export interface EntityDto {
    id: number;
}

export interface CreateAttributeValueDto {
    value: string;
    attributeId: number;
}

export interface ListResultDtoOfSearchOutputDto {
    items: SearchOutputDto[];
}

export interface ShoppingCartDto {
    productEntries: ProductEntry[];
    totalPrice: number;
    savedAt: number;
    // locationId: number;
}

export interface ProductEntry {
    count: number;
    price: number;
    product: ProductListDto;
}

export interface ProductListDto {
    name: string;
    sku: string;
    price: number;
    description: string;
    productSectionId: number;
    picture: ProductPictureDto;
    id: number;
}

export interface ProductPictureDto {
    pictureUrl: string;
    name: string;
    id: number;
}


export interface SearchOutputDto {
    displayValue: string;
    id: number;
}

export interface CreateCatalogDto {
    name: string;
    divisionId: number;
}

export interface EntityDtoOfInt64 {
    id: number;
}

export interface AddOrRemoveProductsInput {
    categoryId: number;
    catalogId: number;
    productIds: number[];
}

export interface AddProductsOutput {
    removedProducts: CategoryProductsDto[];
}

export interface CategoryProductsDto {
    name: string;
    productIds: number[];
    id: number;
}

export interface EditCatalogDto {
    name: string;
    id: number;
}

export interface PagedResultDtoOfClientCatalogDto {
    totalCount: number;
    items: ClientCatalogDto[];
}

export interface ClientCatalogDto {
    catalogId: number;
    clientName: string;
    divisionName: string;
}

export interface UpdateCatalogDto {
    name: string;
    id: number;
}

export interface CreateClientCategoryDto {
    catalogId: number;
    parentCategoryId: number;
    name: string;
    sortingPriority: number;
}

export interface CreateCategoryDto {
    parentCategoryId: number;
    name: string;
    sortingPriority: number;
}

export interface ListResultDtoOfGetСategoriesDto {
    items: GetСategoriesDto[];
}

export interface GetСategoriesDto {
    id: number;
    name: string;
    childCategories: GetСategoriesDto[];
    sortingPriority: number;
}

export interface UpdateCategoryDto {
    id: number;
    name: string;
    sortingPriority: number;
}

export interface CreateClientDto {
    name: string;
    scManagerId: number;
    numberOfDivisions: number;
    numberOfEmployees: number;
    numberOfPhysicians: number;
    numberOfLocations: number;
    medicalSpecialityId: number;
    historicalAnnualSpend: number;
    startDate: moment.Moment;
    primaryPreviousSuppliers: string[];
    meetingSchedule: string;
    orderingRestriction: string;
    approvalRestriction: string;
}

export interface PagedResultDtoOfClientListDto {
    totalCount: number;
    items: ClientListDto[];
}

export interface ClientListDto {
    name: string;
    numberOfDivisions: number;
    numberOfLocations: number;
    numberOfEmployeesTotal: string;
    id: number;
}

export interface EditClientDto {
    name: string;
    numberOfDivisions: number;
    numberOfEmployees: number;
    numberOfPhysicians: number;
    numberOfLocations: number;
    medicalSpeciality: SearchOutputDto;
    historicalAnnualSpend: number;
    startDate: moment.Moment;
    primaryPreviousSuppliers: string[];
    scManager: SearchOutputDtoOfInt64;
    meetingSchedule: string;
    orderingRestriction: string;
    approvalRestriction: string;
    id: number;
}

export interface SearchOutputDtoOfInt64 {
    displayValue: string;
    id: number;
}

export interface ListResultDtoOfClientUnitShortDto {
    items: ClientUnitShortDto[];
}

export interface ClientUnitShortDto {
    name: string;
    children: ClientUnitShortDto[];
    type: ClientUnitShortDtoType;
    catalogId: number;
    id: number;
}

export interface UpdateClientDto {
    id: number;
    name: string;
    scManagerId: number;
    numberOfDivisions: number;
    numberOfEmployees: number;
    numberOfPhysicians: number;
    numberOfLocations: number;
    medicalSpecialityId: number;
    historicalAnnualSpend: number;
    startDate: moment.Moment;
    primaryPreviousSuppliers: string[];
    meetingSchedule: string;
    orderingRestriction: string;
    approvalRestriction: string;
}

export interface CreateDivisionDto {
    parentId: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    stateId: number;
}

export interface PagedResultDtoOfDivisionListDto {
    totalCount: number;
    items: DivisionListDto[];
}

export interface DivisionListDto {
    name: string;
    catalog: CatalogDto;
    id: number;
}

export interface CatalogDto {
    name: string;
    id: number;
}

export interface EditDivisionDto {
    name: string;
    parentId: number;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    state: SearchOutputDto;
    id: number;
}

export interface UpdateDivisionDto {
    id: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    stateId: number;
}

export interface PagedResultDtoOfClientInvoiceListDto {
    totalCount: number;
    items: ClientInvoiceListDto[];
}

export interface ClientInvoiceListDto {
    id: number;
    number: string;
    creationTime: moment.Moment;
    divisionName: string;
    locationName: string;
    totalAmount: number;
    hasBeenPaid: boolean;
    hasBeenSent: boolean;
}

export interface PagedResultDtoOfInvoceListDto {
    totalCount: number;
    items: InvoceListDto[];
}

export interface InvoceListDto {
    id: number;
    number: string;
    creationTime: moment.Moment;
    divisionName: string;
    locationName: string;
    totalAmount: number;
    hasBeenPaid: boolean;
    hasBeenSent: boolean;
}

export interface EditClientInvoiceDto {
    additionalChargeReason: string;
    additionalChargeAmount: number;
    additionalChargeIsTaxable: boolean;
    number: string;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    isVisibleToClient: boolean;
    hasBeenPaid: boolean;
    owner: SearchOutputDto;
    totalAmount: number;
    subTotalAmount: number;
    taxRate: number;
    taxesTotal: number;
    items: EditClientInvoiceItemDto[];
    id: number;
}

export interface UpdateInvoicePaidStatusDto{
    id: number;
    hasBeenPaid: boolean;
}

export interface EditClientInvoiceItemDto {
    product: ProductShortDto;
    quantity: number;
    price: number;
    sku: string;
    productName: string;
    packageType: SearchOutputDto;
    isZeroPrice: boolean;
    zeroPriceNote: string;
    subTotalAmount: number;
    isTaxable: boolean;
    note: NoteSearchOutputDto;
    manualEntry: InvoiceManualEntryDto;
    id: number;
}

export interface ProductShortDto {
    name: string;
    sku: string;
    picture: ProductPictureDto;
    id: number;
}

export interface NoteSearchOutputDto {
    isManualEntryRequired: boolean;
    manualEntryType: NoteSearchOutputDtoManualEntryType;
    displayValue: string;
    id: number;
}

export interface InvoiceManualEntryDto {
    isAmountIncludedToInvoice: boolean;
    subTotalAmount: number;
    sku: string;
    description: string;
    price: number;
    quantity: number;
    isTaxable: boolean;
}

export interface ProductPictureDto {
    pictureUrl: string;
    name: string;
    id: number;
}

export interface InvoiceDetailsDto {
    number: string;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    owner: SearchOutputDto;
    totalAmount: number;
    subTotalAmount: number;
    taxRate: number;
    taxesTotal: number;
    items: InvoiceDetailsItemDto[];
    hasBeenPaid: boolean;
    id: number;
}

export interface InvoiceDetailsItemDto {
    product: ProductShortDto;
    quantity: number;
    price: number;
    sku: string;
    productName: string;
    packageType: SearchOutputDto;
    isZeroPrice: boolean;
    zeroPriceNote: string;
    subTotalAmount: number;
    isTaxable: boolean;
    note: NoteSearchOutputDto;
    manualEntry: InvoiceManualEntryDto;
    id: number;
}

export interface UpdateClientInvoiceDto {
    items: UpdateClientInvoiceItemDto[];
    itemsWithAmountIncludedToInvoice: number[];
    id: number;
    additionalChargeAmount: number;
    additionalChargeReason: string;
    additionalChargeIsTaxable: boolean;
}

export interface UpdateClientInvoiceItemDto {
    price: number;
    packageTypeId: number;
    isAmountIncludedToInvoice: boolean;
    quantity: number;
    isZeroPrice: boolean;
    zeroPriceNote: string;
    id: number;
}

export interface SendClientInvoiceDto {
    invoices: number[];
}

export interface CreateLocationDto {
    parentId: number;
    name: string;
    physicianName: string;
    physicianLicenseNumber: string;
    physicianLicenseExpirationDate: moment.Moment;
    physicianDeaExpirationDate: moment.Moment;
    physicianNpiNumber: string;
    physicianDeaNumber: string;
    facilityOrLocationCode: string;
    isInHospital: boolean;
    operationStartTime: string;
    operationEndTime: string;
    taxRate: number;
    phoneNumber: string;
    faxNumber: string;
    address1: string;
    address2: string;
    vendorAccountNumbers: VendorAccountNumberDto[];
    city: string;
    zipCode: string;
    stateId: number;
}

export interface VendorAccountNumberDto {
    vendorId: number;
    accountNumber: string;
}

export interface CreateAddressOverrideDto {
    address1: string;
    address2: string;
    city: string;
    stateId: number;
    zipCode: string;
    phoneNumber: string;
    userId: number;
    clientUnitId: number;
    name: string;
}

export interface PagedResultDtoOfLocationListDto {
    totalCount: number;
    items: LocationListDto[];
}

export interface LocationListDto {
    name: string;
    city: string;
    state: string;
    zipCode: string;
    id: number;
}

export interface EditLocationDto {
    parentId: number;
    name: string;
    physicianName: string;
    physicianLicenseNumber: string;
    physicianLicenseExpirationDate: moment.Moment;
    physicianDeaExpirationDate: moment.Moment;
    physicianNpiNumber: string;
    physicianDeaNumber: string;
    facilityOrLocationCode: string;
    isInHospital: boolean;
    operationStartTime: string;
    operationEndTime: string;
    taxRate: number;
    phoneNumber: string;
    faxNumber: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    vendorAccountNumbers: VendorAccountNumberOutput[];
    state: SearchOutputDto;
    id: number;
}

export interface VendorAccountNumberOutput {
    vendor: SearchOutputDtoOfInt64;
    accountNumber: string;
}

export interface EditAddressOverrideDto {
    address1: string;
    address2: string;
    city: string;
    stateId: number;
    zipCode: string;
    phoneNumber: string;
    userId: number;
    clientUnitId: number;
    name: string;
    id: number;
}

export interface UpdateLocationDto {
    id: number;
    name: string;
    physicianName: string;
    physicianLicenseNumber: string;
    physicianLicenseExpirationDate: moment.Moment;
    physicianDeaExpirationDate: moment.Moment;
    physicianNpiNumber: string;
    physicianDeaNumber: string;
    facilityOrLocationCode: string;
    isInHospital: boolean;
    operationStartTime: string;
    operationEndTime: string;
    taxRate: number;
    phoneNumber: string;
    faxNumber: string;
    address1: string;
    address2: string;
    vendorAccountNumbers: VendorAccountNumberDto[];
    city: string;
    zipCode: string;
    stateId: number;
}

export interface UpdateAddressOverrideDto {
    id: number;
    address1: string;
    address2: string;
    city: string;
    stateId: number;
    zipCode: string;
    phoneNumber: string;
    userId: number;
    clientUnitId: number;
    name: string;
}

export interface ListResultDtoOfNoteSearchOutputDto {
    items: NoteSearchOutputDto[];
}

export interface SaveOrderDto {
    locationId: number;
    items: CartItemDto[];
}

export interface CartItemDto {
    productId: number;
    count: number | string;
}

export interface SubmitOrderInputDto {
    locationId: number;
    items: SubmitOrderItem[];
    comment: string;
}

export interface SubmitOrderItem {
    productId: number;
    quantity: number | string;
    price: number;
}

export interface PagedResultDtoOfMyOrdersListDto {
    totalCount: number;
    items: MyOrdersListDto[];
}

export interface MyOrdersListDto {
    submittedOn: moment.Moment;
    address: string;
    number: string;
    processingStatus: string;
    id: number;
}

export interface EditMyOrderDto {
    number: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    items: MyOrderItemDto[];
    subTotalAmount: number;
    id: number;
}

export interface MyOrderItemDto {
    product: ProductShortDto;
    quantity: number;
    price: number;
    subTotalAmount: number;
}

export interface PagedResultDtoOfBuyerOrderListDto {
    totalCount: number;
    items: BuyerOrderListDto[];
}

export interface BuyerOrderListDto {
    ownerName: string;
    number: string;
    submittingTime: moment.Moment;
    subTotalAmount: number;
    approvalStatus: string;
    status: string;
    statusId: BuyerOrderListDtoStatusId;
    locationName: string;
    shouldBeSubmitted: boolean;
    shouldBeApproved: boolean;
    id: number;
}

export interface EditAllOrderDto {
    approvalLimit: UserSpendLimiDto;
    number: string;
    clientPoNumber: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    subTotalAmount: number;
    items: BuyerOrderItemDto[];
    shouldBeSubmitted?: boolean;
    shouldBeApproved?: boolean;
    comment?: string;
    id: number;
}

export interface UserSpendLimiDto {
    limit: number;
    unlimited: boolean;
}

export interface BuyerOrderItemDto {
    isActive: boolean;
    product: ProductShortDto;
    quantity: number;
    price: number;
    subTotalAmount: number;
}

export interface PagedResultDtoOfSCMDashboardOrderListDto {
    totalCount: number;
    items: SCMDashboardOrderListDto[];
}

export interface SCMDashboardOrderListDto{
    submittingTime: moment.Moment;
    buyerName: string;
    locationName: string;
    orderNumber: string;
    approvalStatus: string;
    orderDetails: DashboardOrderDetail;
}

export interface DashboardOrderDetail{
    vendors?: string[];
    approvers?: DashboardApprover[];
}

export interface DashboardApprover{
    position: number;
    approved: boolean;
    fullName: string;
}

export interface PagedResultDtoOfUncomparedOrdersListDto {
    totalCount: number;
    items: UncomparedOrdersListDto[];
}

export interface UncomparedOrdersListDto {
    submittingTime: moment.Moment;
    clientName: string;
    ownerName: string;
    address: string;
    locationName: string;
    processed: string;
    number: string;
    isApproved: boolean;
    id: number;
}

export interface PagedResultDtoOfPackingSlipOrdersListDto {
    totalCount: number;
    items: PackingSlipOrdersListDto[];
}

export interface PackingSlipOrdersListDto {
    submittingTime: moment.Moment;
    address: string;
    number: string;
    packingSlipStatus: string;
    ownerName: string;
    id: number;
}

export interface PackingSlipDetailsDto {
    number: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    items: PackingSlipOrderItemDto[];
    id: number;
}

export interface PackingSlipOrderItemDto {
    product: ProductShortDto;
    price: number;
    quantity: number;
    quantityReceived: number;
    quantityReturned: number;
    isNeedToReturn: boolean;
    isRecived: boolean;
    note: NoteSearchOutputDto;
    manualEntry: ManualEntryDto;
    id: number;
    reason?: string;
    details?: string;
}

export interface ManualEntryDto {
    sku: string;
    description: string;
    price: number;
    quantity: number;
    isTaxable: boolean;
}

export interface EditBuyerOrderDto {
    number: string;
    clientPoNumber: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    subTotalAmount: number;
    items: BuyerOrderItemDto[];
    shouldBeSubmitted?: boolean;
    shouldBeApproved?: boolean;
    comment?: string;
    id: number;
}

export interface EditUncomparedOrderDto {
    number: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    subTotalAmount: number;
    location: SearchOutputDto;
    items: UncomparedOrderItemDto[];
    isApproved: boolean;
}

export interface UncomparedOrderItemDto {
    product: ProductShortDto;
    quantity: number;
    price: number;
    subTotalAmount: number;
    note: NoteSearchOutputDto;
    manualEntry: ManualEntryDto;
    id: number;
}

export interface EditPackingSlipOrderDto {
    number: string;
    creatorUser: SearchOutputDto;
    creationTime: moment.Moment;
    location: SearchOutputDto;
    items: PackingSlipOrderItemDto[];
    id: number;
}

export interface ErrorsOutputDto {
    success: boolean;
    errors: string[];
}

export interface UpdateOrderDto {
    items: OrderItemDto[];
    id: number;
    clientPoNumber: string;
}

export interface OrderItemDto {
    isActive: boolean;
    productId: number;
    quantity: number;
}

export interface UpdateUncomparedOrderDto {
    items: UpdateUncomparedOrderItem[];
    id: number;
}

export interface UpdateUncomparedOrderItem {
    noteId: number;
    manualEntry: ManualEntryDto;
    id: number;
}

export interface UpdatePackingSlipOrderDto {
    items: UpdatePackingSlipOrderItemDto[];
    id: number;
}

export interface UpdatePackingSlipOrderItemDto {
    quantityReceived: number;
    quantityReturned: number;
    isNeedToReturn: boolean;
    isRecived: boolean;
    reason?: string;
    details?: string;
    id: number;
}

export interface UpdatePackingSlipOutput {
    emailSent: boolean;
}

export interface ListResultDtoOfPermissionNodeDto {
    items: PermissionNodeDto[];
}

export interface PermissionNodeDto {
    parentName: string;
    name: string;
    displayName: string;
    children: PermissionNodeDto[];
}

export interface ListResultDtoOfString {
    items: string[];
}

export interface ListResultDtoOfPricingDetailDto {
    items: PricingDetailDto[];
}

export interface PricingDetailDto {
    catalogId: number;
    price: number;
    glCode: string;
    needsApproval: number;
}

export interface ProductPriceDto {
    productId: number;
    price: number;
}

export interface ListResultDtoOfProductPriceDto {
    items: ProductPriceDto[];
}

export interface SetPricesForCatalogsInput {
    productId: number;
    pricingDetails: SetPriceDetailDto[];
}

export interface SetPriceDetailDto {
    catalogId: number;
    price: number;
    glCode: string;
    needsApproval: number;

}

export interface CreateProductDto {
    pictures: FileAttachmentDto[];
    skuPrefixId: number;
    middleSku: string;
    skuSuffixId: number;
    description: string;
    length: number;
    width: number;
    height: number;
    upc: number;
    glCategoryNumber: string;
    allocationCode: string;
    quantityPerUnitOfMeasure: number;
    nameSegments: string[];
    similarProducts: number[];
    attributes: ProductAttributeDto[];
    categoryId: number;
    dimensionId: number;
    packageTypeId: number;
    isPathThrough: boolean;
    deliveryTime: string;
    manufacturer: string;
    manufacturerNumber: string;
    vendorId: number;
    vendorPriceDate: moment.Moment;
    vendorPrice: number;
    itemNumber: string;
    hazmatCharge: number;
    isSterile: boolean;
    latexStatus: CreateProductDtoLatexStatus;
    stockStatus: CreateProductDtoStockStatus;
    contractStatus?: CreateProductDtoContractStatus;
    productSectionId: number;
    isHazardousMaterial: boolean;
    isControlledSubstance: boolean;
    isForm222: boolean;
    isReturnable: boolean;
    isTaxable: boolean;
}

export interface FileAttachmentDto {
    fileName: string;
    mimeType: string;
    file: string;
    priority: number;
    id: number;
}

export interface ProductAttributeDto {
    attributeValueId: number;
    includeIntoName: boolean;
}

export interface PagedResultDtoOfProductListDto {
    totalCount: number;
    items: ProductListDto[];
}

export interface ProductListDto {
    name: string;
    sku: string;
    description: string;
    productSectionId: number;
    picture: ProductPictureDto;
    id: number;
}

export interface ListResultDtoOfSimilarProductDto {
    items: SimilarProductDto[];
}

export interface SimilarProductDto {
    name: string;
    sku: string;
    picture: ProductPictureDto;
    id: number;
}

export interface ListResultDtoOfClientSimilarProductDto {
    items: ClientSimilarProductDto[];
}

export interface ClientSimilarProductDto {
    price: number;
    name: string;
    sku: string;
    picture: ProductPictureDto;
    id: number;
}

export interface ProductDetailsDto {
    pictures: ProductPictureDto[];
    name: string;
    sku: string;
    description: string;
    length: number;
    width: number;
    height: number;
    quantityPerUnitOfMeasure: number;
    dimension: string;
    packageType: string;
    deliveryTime: string;
    hazmatCharge: number;
    isHazardousMaterial: boolean;
    latexStatus: ProductDetailsDtoLatexStatus;
    isSterile: boolean;
    manufacturer: string;
    manufacturerNumber: string;
    isControlledSubstance: boolean;
    isForm222: boolean;
    isReturnable: boolean;
    productSectionId: number;
    id: number;
}

export interface ClientProductDetailsDto {
    price: number;
    pictures: ProductPictureDto[];
    name: string;
    sku: string;
    description: string;
    length: number;
    width: number;
    height: number;
    quantityPerUnitOfMeasure: number;
    dimension: string;
    packageType: string;
    deliveryTime: string;
    hazmatCharge: number;
    isHazardousMaterial: boolean;
    latexStatus: ClientProductDetailsDtoLatexStatus;
    isSterile: boolean;
    manufacturer: string;
    manufacturerNumber: string;
    isControlledSubstance: boolean;
    isForm222: boolean;
    isReturnable: boolean;
    productSectionId: number;
    id: number;
}

export interface ListResultDtoOfSearchProductAttributeDto {
    items: SearchProductAttributeDto[];
}

export interface SearchProductAttributeDto {
    include: boolean;
    attribute: SearchOutputDto;
    attributeValue: SearchOutputDto;
}

export interface EditProductDto {
    pictures: ProductPictureDto[];
    skuPrefix: SearchOutputDtoOfInt64;
    middleSku: string;
    skuSuffix: SearchOutputDtoOfInt64;
    manufacturerNumber: string;
    description: string;
    length: number;
    width: number;
    height: number;
    upc: number;
    glCategoryNumber: string;
    allocationCode: string;
    quantityPerUnitOfMeasure: number;
    isPathThrough: boolean;
    nameSegments: string[];
    categoryId: number;
    dimension: SearchOutputDto;
    packageType: SearchOutputDto;
    deliveryTime: string;
    manufacturer: string;
    vendor: SearchOutputDtoOfInt64;
    vendorPriceDate: moment.Moment;
    vendorPrice: number;
    itemNumber: string;
    hazmatCharge: number;
    isSterile: boolean;
    latexStatus: EditProductDtoLatexStatus;
    stockStatus: EditProductDtoStockStatus;
    contractStatus?: EditProductDtoContractStatus;
    productSection: SearchOutputDto;
    isHazardousMaterial: boolean;
    isControlledSubstance: boolean;
    isForm222: boolean;
    isReturnable: boolean;
    isTaxable: boolean;
    id: number;
}

export interface ListResultDtoOfSearchSimilarProductDto {
    items: SearchSimilarProductDto[];
}

export interface SearchSimilarProductDto {
    name: string;
    sku: string;
    id: number;
}

export interface ListResultDtoOfCategoryProductDto {
    items: CategoryProductDto[];
}

export interface CategoryProductDto {
    sku: string;
    name: string;
    id: number;
}

export interface ListResultDtoOfCountDtoOfInt64 {
    items: CountDtoOfInt64[];
}

export interface CountDtoOfInt64 {
    count: number;
    id: number;
}

export interface UpdateProductDto {
    id: number;
    pictures: FileAttachmentDto[];
    skuPrefixId: number;
    middleSku: string;
    skuSuffixId: number;
    description: string;
    length: number;
    width: number;
    height: number;
    upc: number;
    glCategoryNumber: string;
    allocationCode: string;
    quantityPerUnitOfMeasure: number;
    nameSegments: string[];
    similarProducts: number[];
    attributes: ProductAttributeDto[];
    categoryId: number;
    dimensionId: number;
    packageTypeId: number;
    isPathThrough: boolean;
    deliveryTime: string;
    manufacturer: string;
    manufacturerNumber: string;
    vendorId: number;
    vendorPriceDate: moment.Moment;
    vendorPrice: number;
    itemNumber: string;
    hazmatCharge: number;
    isSterile: boolean;
    latexStatus: UpdateProductDtoLatexStatus;
    stockStatus: UpdateProductDtoStockStatus;
    contractStatus?: UpdateProductDtoContractStatus;
    productSectionId: number;
    isHazardousMaterial: boolean;
    isControlledSubstance: boolean;
    isForm222: boolean;
    isReturnable: boolean;
    isTaxable: boolean;
}

export interface PagedResultDtoOfPurchasedProductsListOutput {
    totalCount: number;
    items: PurchasedProductsListOutput[];
}

export interface PurchasedProductsListOutput {
    name: string;
    sku: string;
    description: string;
    picture: ProductPictureDto;
    isDiscontinued: boolean;
    price: number;
    productSectionId: number;
    id: number;
}

export interface CreateRoleDto {
    name: string;
    permissions: string[];
}

export interface RoleDto {
    name: string;
    permissions: string[];
    creationTime: moment.Moment;
    id: number;
}

export interface PagedResultDtoOfListRoleDto {
    totalCount: number;
    items: ListRoleDto[];
}

export interface ListRoleDto {
    name: string;
    creationTime: moment.Moment;
    permissions: string[];
    id: number;
}

export interface UpdateRoleDto {
    name: string;
    permissions: string[];
    id: number;
}

export interface GetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    grantedPermissionNames: string[];
    assignedRoleNames: string[];
    availableLocations: ClientUnitShortDto[];
}

export interface ApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; };
}

export interface UserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    id: number;
}

export interface CreateSkuDto {
    name: string;
}

export interface ListResultDtoOfSearchOutputDtoOfInt64 {
    items: SearchOutputDtoOfInt64[];
}

export interface ListResultDtoOfUserSupervisorDto {
    items: UserSupervisorDto[];
}

export interface UserSupervisorDto {
    order: number;
    userId: number;
    userName: string;
    supervisorId: number;
    supervisorName: string;
    locationId: number;
    locationName: string;
    approvalLimit: number;
    unlimited: boolean;
    id: number;
}

export interface UpdateUserSupervisorsInput {
    userId: number;
    userSupervisors: UserSupervisorDto[];
}

export interface AuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export interface AuthenticateModelWithConfirmPassword {
    password: string;
    confirmPassword: string;
    rememberClient: boolean;
}

export interface AuthenticateModelWithEmail{
    email: string;
}

export interface AuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    userId: number;
}

export interface ExternalLoginProviderInfoModel {
    name: string;
    clientId: string;
}

export interface ExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export interface ExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export interface CreateUnitOfMeasureInput {
    name: string;
}

export interface EntityDtoOfInt32 {
    id: number;
}

export interface CreateUserDto {
    clientUnitIds: number[];
    userName: string;
    name: string;
    surname: string;
    phoneNumber: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[];
    userSupervisors: UserSupervisorDto[];
    spendingTermId: number;
    limit: number;
    unlimited: boolean;
}

export interface CheckSpendLimitOutput {
    canBeSubmitted: boolean;
    warningMessages: string[];
}

export interface PagedResultDtoOfListUserDto {
    totalCount: number;
    items: ListUserDto[];
}

export interface ListUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string;
    isActive: boolean;
    role: string;
    clientName: string;
    id: number;
}

export interface EditUserDto {
    clientUnitIds: number[];
    roles: string[];
    userName: string;
    name: string;
    surname: string;
    phoneNumber: string;
    emailAddress: string;
    spendingTerm: SearchOutputDto;
    limit: number;
    unlimited: boolean;
    isActive: boolean;
    id: number;
}

export interface ListResultDtoOfAddressOverrideListDto {
    items: AddressOverrideListDto[];
}

export interface AddressOverrideListDto {
    name: string;
    clientUnitId: number;
    id: number;
}

export interface UpdateUserDto {
    clientUnitIds: number[];
    userName: string;
    name: string;
    surname: string;
    phoneNumber: string;
    emailAddress: string;
    roleNames: string[];
    userSupervisors: UserSupervisorDto[];
    spendingTermId: number;
    limit: number;
    unlimited: boolean;
    id: number;
}

export interface ResetPasswordDto{
    password: string;
    PasswordResetCode: string;
    id: number;
}
export interface ResetPasswordEmailDto{
    emailAddress?: string;
    userId?: number;
}
export interface UpdateUserPermissionsInput {
    userId: number;
    grantedPermissionNames: string[];
}
export interface CreateVendorDto {
    name: string;
    email: string;
    transmissionType: CreateVendorDtoTransmissionType;
    vendorId?: string;
}

export interface PagedResultDtoOfVendorListDto {
    totalCount: number;
    items: VendorListDto[];
}

export interface VendorListDto {
    name: string;
    email: string;
    transmissionType: string;
    id: number;
}

export interface EditVendorDto {
    name: string;
    email: string;
    transmissionType: EditVendorDtoTransmissionType;
    id: number;
    vendorId?: string;
}

export interface SearchInputDto {
    maxResultCount: number;
    filter: string;
}

export interface UpdateVendorDto {
    id: number;
    name: string;
    email: string;
    transmissionType: UpdateVendorDtoTransmissionType;
    vendorId?: string;
}

export enum ClientUnitType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ClientUnitShortDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum NoteSearchOutputDtoManualEntryType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6
}

export enum BuyerOrderListDtoStatusId {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CreateProductDtoLatexStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CreateProductDtoStockStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CreateProductDtoContractStatus{
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ProductDetailsDtoLatexStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ClientProductDetailsDtoLatexStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EditProductDtoLatexStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EditProductDtoStockStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EditProductDtoContractStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum UpdateProductDtoLatexStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum UpdateProductDtoStockStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum UpdateProductDtoContractStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateVendorDtoTransmissionType {
    _1 = 1,
    _2 = 2,
}

export enum EditVendorDtoTransmissionType {
    _1 = 1,
    _2 = 2,
}

export enum UpdateVendorDtoTransmissionType {
    _1 = 1,
    _2 = 2,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}